import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "../api/client";
import { logger } from "./logger";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retrying cannot fix a refused or missing request.
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => logger.warn("request failed", error),
    },
  },
});
